import { ContactDetails } from "./ContactDetails";
import { ContactPerson } from "./ContactPerson";

export class Me{
    contactDetails: ContactDetails
    person: ContactPerson
    avatarS3Key: string
}